import { c as _c } from "react/compiler-runtime";
import { IconButton } from "@flat-ui";
import { clickDisabledStyle, hoverDisabledStyle } from "@styles/common-styles";
import { clickStyle, getSvgColoredIconCss, hoverStyle } from "@utils/ui-utils";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { PALETTE_VARS } from "@styles/palette-vars";
/**
 * Renders a flat-ui IconButton component that has an SvgIcon component inside.
 * This component is preferred over using IconButton because it has some
 * default properties and animations like color to blue the icon on hover.
 */
export function SphereIconButton(t0) {
  const $ = _c(48);
  const {
    iconButtonProps,
    id,
    onClick,
    onAuxClick,
    onContextMenu,
    component,
    iconProps,
    color: t1,
    disabledColor: t2,
    buttonSize: t3,
    iconSize: t4,
    isDisabled,
    isHidden: t5,
    href,
    target,
    rel,
    dataTestId
  } = t0;
  const color = t1 === undefined ? PALETTE_VARS.text.primary : t1;
  const disabledColor = t2 === undefined ? PALETTE_VARS.text.disabled : t2;
  const buttonSize = t3 === undefined ? "36px" : t3;
  const iconSize = t4 === undefined ? "24px" : t4;
  const isHidden = t5 === undefined ? false : t5;
  const Icon = component;
  let t6;
  bb0: {
    if (!href) {
      let t7;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {};
        $[0] = t7;
      } else {
        t7 = $[0];
      }
      t6 = t7;
      break bb0;
    }
    let t7;
    if ($[1] !== href || $[2] !== rel || $[3] !== target) {
      t7 = {
        LinkComponent: Link,
        to: href,
        href,
        target,
        rel
      };
      $[1] = href;
      $[2] = rel;
      $[3] = target;
      $[4] = t7;
    } else {
      t7 = $[4];
    }
    t6 = t7;
  }
  const linkProps = t6;
  if (isHidden) {
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <></>;
      $[5] = t7;
    } else {
      t7 = $[5];
    }
    return t7;
  }
  let t7;
  if ($[6] !== isDisabled) {
    t7 = function onInnerClick(event, clickCallback) {
      if (isDisabled || !clickCallback) {
        return;
      }
      clickCallback(event);
    };
    $[6] = isDisabled;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const onInnerClick = t7;
  let t8;
  if ($[8] !== onClick || $[9] !== onInnerClick) {
    t8 = event_0 => onInnerClick(event_0, onClick);
    $[8] = onClick;
    $[9] = onInnerClick;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== onAuxClick || $[12] !== onInnerClick) {
    t9 = event_1 => onInnerClick(event_1, onAuxClick);
    $[11] = onAuxClick;
    $[12] = onInnerClick;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== onContextMenu || $[15] !== onInnerClick) {
    t10 = event_2 => onInnerClick(event_2, onContextMenu);
    $[14] = onContextMenu;
    $[15] = onInnerClick;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== iconSize) {
    t11 = {
      height: iconSize,
      width: iconSize
    };
    $[17] = iconSize;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = isDisabled ? hoverDisabledStyle : hoverStyle;
  let t13;
  if ($[19] !== t12) {
    t13 = {
      ...t12
    };
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const t14 = isDisabled ? clickDisabledStyle : clickStyle;
  let t15;
  if ($[21] !== t14) {
    t15 = {
      ...t14
    };
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  const t16 = iconButtonProps?.sx;
  let t17;
  if ($[23] !== buttonSize || $[24] !== t11 || $[25] !== t13 || $[26] !== t15 || $[27] !== t16) {
    t17 = {
      height: buttonSize,
      width: buttonSize,
      "&>:first-of-type": t11,
      "&:hover": t13,
      "&:active": t15,
      ...t16
    };
    $[23] = buttonSize;
    $[24] = t11;
    $[25] = t13;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  const t18 = isDisabled ? disabledColor : color;
  let t19;
  if ($[29] !== t18) {
    t19 = getSvgColoredIconCss(t18);
    $[29] = t18;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== iconSize || $[32] !== t19) {
    t20 = {
      ...t19,
      height: iconSize,
      width: iconSize
    };
    $[31] = iconSize;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== Icon || $[35] !== iconProps || $[36] !== t20) {
    t21 = <Icon sx={t20} {...iconProps} />;
    $[34] = Icon;
    $[35] = iconProps;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== dataTestId || $[39] !== iconButtonProps || $[40] !== id || $[41] !== linkProps || $[42] !== t10 || $[43] !== t17 || $[44] !== t21 || $[45] !== t8 || $[46] !== t9) {
    t22 = <IconButton id={id} disabled={false} disableRipple={true} draggable={false} color="inherit" hoverColor="inherit" margin={0} data-testid={dataTestId} onClick={t8} onAuxClick={t9} onContextMenu={t10} {...iconButtonProps} sx={t17} {...linkProps}>{t21}</IconButton>;
    $[38] = dataTestId;
    $[39] = iconButtonProps;
    $[40] = id;
    $[41] = linkProps;
    $[42] = t10;
    $[43] = t17;
    $[44] = t21;
    $[45] = t8;
    $[46] = t9;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  return t22;
}